// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__HylER"};